import React from "react";

const FootNav = () => {
  return (
    <div className="footer">
      <p> © Developed by Khaldoon, Knar, Hiba</p>

      <p>
        <a href="https://www.freepik.com/vectors/social-media">
          Social media vector created by stories - www.freepik.com
        </a>
      </p>
    </div>
  );
};

export default FootNav;
